import { useQuery } from '@tanstack/react-query';

import { backupInvitesClient } from '../api/backupInvites';
import { dashboardV2QueryKeys } from '../api/queryKeys';

import useAuth from '@/hooks/useAuth';

/**
 * "Auto backups on" in the Dashboard V2 header (GRAVY-10898), while the GLOBAL
 * backup-invites switch is on: GravyWork can then invite backups and hire from
 * standby without ops being asked, wherever a client, order or job has auto
 * backups turned on, so whether that can run should be visible at a glance.
 * Nothing while it is off — the Invite backups modal says so where it matters.
 *
 * Tenant admins only: the switch endpoint is TENANT_ADMIN-role only, so
 * anyone else would only ever get a 403.
 */
const BackupsOnPill = () => {
  const { currentAdminIsTenantAdmin } = useAuth();
  const { data } = useQuery({
    queryKey: dashboardV2QueryKeys.backupSwitch(),
    queryFn: () => backupInvitesClient.getSwitch(),
    enabled: !!currentAdminIsTenantAdmin,
    staleTime: 60_000,
    retry: false,
  });

  if (!currentAdminIsTenantAdmin || !data?.enabled) return null;

  return (
    <span
      className="dashv2-backups-pill"
      data-testid="dashboard-backups-on"
      title="Auto backups are on. They run for clients, orders and jobs where they're turned on."
    >
      Auto backups on
    </span>
  );
};

export default BackupsOnPill;
